export default __webpack_public_path__ + "img/visa-1652d7ab22d06b1e851245937aa95171.png";